export function getReplyCommentParams(data, storyId, parentId) {
  return {
    ...data,
    body: data.reply,
    commentable_type: 'Story',
    commentable_id: storyId,
    parent_id: parentId
  };
}

export function getAnnotationParams(targetIds) {
  return {
    target_id: targetIds,
    target_type: 'Content'
  };
}



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/utils.js